export default function ingredientAmounts() {
  const totalAmountEl = document.querySelector('.js-amount');

  function formatNumber(number) {
    // Convert the number to a string with a specific format
    const formattedNumber = number.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    // Replace the dot with a comma
    const finalResult = formattedNumber.replace('.', ',');

    return finalResult;
  }

  if (totalAmountEl) {
    const ingredientAmountEls = document.querySelectorAll('.js-ingredient-amount');
    const increaseIngredientAmounts = document.querySelectorAll('.js-amount-increase');
    const decreaseIngredientAmounts = document.querySelectorAll('.js-amount-decrease');
    let amountCounter = parseFloat(totalAmountEl.dataset.amount);
    const amountOfPeople = parseFloat(totalAmountEl.dataset.amount);
    const addToGroceryListEl = document.querySelector('.js-add-to-grocery-list');
    const groceryListEl = document.querySelector('.js-grocery-list');

    const amountFromHash = parseFloat(window.location.hash.substring(1));
    if (amountFromHash > 0) {
      amountCounter = amountFromHash;

      totalAmountEl.dataset.amount = amountFromHash;
      totalAmountEl.innerHTML = amountFromHash;
      addToGroceryListEl.setAttribute('data-amount-of-people', amountFromHash);

      ingredientAmountEls.forEach((ingredientAmountEl) => {
        const { amountSingle } = ingredientAmountEl.dataset;
        const newValue = parseFloat(amountSingle) * parseFloat(amountFromHash);

        if (amountSingle.includes('.')) {
          ingredientAmountEl.dataset.amountCurrent = newValue.toFixed(2);
          ingredientAmountEl.innerHTML = newValue.toFixed(2).replace('.', ',');
        } else {
          ingredientAmountEl.dataset.amountCurrent = newValue;
          ingredientAmountEl.innerHTML = newValue;
        }
      });
    }

    increaseIngredientAmounts.forEach((increaseButton) => {
      increaseButton.addEventListener('click', (el) => {
        const { articleId } = el.target.dataset;
        const amountElToChange = document.querySelector(
          `.js-amount[data-article-id="${articleId}"]`,
        );
        const amountOfPeopleFromArticle = parseFloat(
          amountElToChange.dataset.originalAmountOfPeople,
        );

        amountCounter += 1;

        const { increase } = el.target.dataset;
        const newAmount = parseFloat(amountElToChange.dataset.amount) + parseFloat(increase);
        amountElToChange.dataset.amount = newAmount;
        amountElToChange.innerHTML = newAmount;

        if (groceryListEl !== null && amountElToChange.dataset.amount > 0) {
          const allItemsWithSameArticleId = document.querySelectorAll(
            `.js-grocery-list-item[data-article-id="${articleId}"]`,
          );

          allItemsWithSameArticleId.forEach((item) => {
            // Check if item.dataset.amount is a valid number
            if (!Number.isNaN(item.dataset.amount)) {
              const newAmountToChangeTo = parseFloat(amountElToChange.dataset.amount).toFixed(2);
              const newAmountVal =
                (parseFloat(item.dataset.originalAmount) / amountOfPeopleFromArticle) *
                parseFloat(amountElToChange.dataset.amount);

              // Round newAmount to two decimal places
              const roundedAmount = parseFloat(newAmountVal.toFixed(2));
              const formattedAmountWithCommas = formatNumber(roundedAmount);

              // Check if roundedAmount has one or zero decimals
              const hasOneOrZeroDecimals = /^(\d+|\d+\.\d{0,1})$/.test(
                formattedAmountWithCommas.toString(),
              );

              // Update the innerHTML of the span element
              const spanElement = item.querySelector('.js-ingredient-amount');

              // TODO: Change the span element when "finish" button is clicked
              if (spanElement) {
                // Display value without decimals if there's one or zero decimals
                spanElement.innerHTML = hasOneOrZeroDecimals
                  ? formattedAmountWithCommas
                  : formattedAmountWithCommas;
              }

              // Update the dataset.amount if needed
              item.dataset.amount = roundedAmount;

              const keyWord = 'AmountOfPeople';
              // Create a new array with modified items
              const newArray = window.groceryList[0]['Aangepaste boodschappenlijst'].map((it) => {
                if (it.includes(keyWord) && it.includes(articleId)) {
                  // Modify the it if both keywords are present
                  return it.replace(
                    /AmountOfPeople:\d+(\.\d+)?=/,
                    `AmountOfPeople:${newAmountToChangeTo}=`,
                  );
                }
                // Keep the it unchanged if it doesn't match the conditions
                return it;
              });

              window.groceryList[0]['Aangepaste boodschappenlijst'] = newArray;
            }
          });
        }

        if (amountCounter > 2 && groceryListEl === null) {
          if (addToGroceryListEl) {
            addToGroceryListEl.setAttribute('data-amount-of-people', newAmount);
          }

          ingredientAmountEls.forEach((ingredientAmountEl) => {
            const { amountSingle } = ingredientAmountEl.dataset;
            const { amountOriginal } = ingredientAmountEl.dataset;
            let newValue =
              (parseFloat(amountOriginal) / parseFloat(amountOfPeople)) * parseFloat(amountCounter);

            if (amountCounter === amountOfPeople) {
              newValue = parseFloat(amountOriginal);
            }

            const roundedValue = parseFloat(newValue.toFixed(2));
            const formattedValue = formatNumber(roundedValue);

            if (amountSingle.includes('.')) {
              // Handle decimal numbers
              ingredientAmountEl.dataset.amountCurrent = roundedValue;
              ingredientAmountEl.innerHTML = formattedValue;
            } else {
              ingredientAmountEl.dataset.amountCurrent = roundedValue;
              ingredientAmountEl.innerHTML = formattedValue;
            }
          });
        }
      });
    });

    decreaseIngredientAmounts.forEach((decreaseButton) => {
      decreaseButton.addEventListener('click', (element) => {
        const { increase } = element.target.dataset;
        const { articleId } = element.target.dataset;
        const amountElToChange = document.querySelector(
          `.js-amount[data-article-id="${articleId}"]`,
        );
        const amountOfPeopleFromArticle = parseFloat(
          amountElToChange.dataset.originalAmountOfPeople,
        );
        const newAmount = parseFloat(amountElToChange.dataset.amount) + parseFloat(increase);
        const { amount } = amountElToChange.dataset;

        if (groceryListEl !== null && amount >= 3) {
          amountElToChange.dataset.amount = newAmount;
          amountElToChange.innerHTML = newAmount;
          const allItemsWithSameArticleId = document.querySelectorAll(
            `.js-grocery-list-item[data-article-id="${articleId}"]`,
          );

          allItemsWithSameArticleId.forEach((el) => {
            // Check if el.dataset.amount is a valid number
            if (!Number.isNaN(el.dataset.amount)) {
              const newAmountToUse =
                (el.dataset.originalAmount / amountOfPeopleFromArticle) *
                amountElToChange.dataset.amount;

              // Round newAmount to two decimal places
              const roundedAmount = parseFloat(newAmountToUse.toFixed(2));
              const formattedAmountWithCommas = formatNumber(roundedAmount);

              // Check if roundedAmount has one or zero decimals
              const hasOneOrZeroDecimals = /^(\d+|\d+\.\d{0,1})$/.test(roundedAmount.toString());

              // Update the innerHTML of the span element
              const spanElement = el.querySelector('.js-ingredient-amount');

              // TODO: Change the span element when "finish" button is clicked
              if (spanElement) {
                // Display value without decimals if there's one or zero decimals
                spanElement.innerHTML = hasOneOrZeroDecimals
                  ? formattedAmountWithCommas
                  : formattedAmountWithCommas;
              }

              // Update the dataset.amount if needed
              el.dataset.amount = roundedAmount;

              const keyWord = 'AmountOfPeople';
              // Create a new array with modified items
              const newArray = window.groceryList[0]['Aangepaste boodschappenlijst'].map((item) => {
                if (item.includes(keyWord) && item.includes(articleId)) {
                  // Modify the item if both keywords are present
                  return item.replace(
                    /AmountOfPeople:\d+(\.\d+)?=/,
                    `AmountOfPeople:${newAmount}=`,
                  );
                }
                // Keep the item unchanged if it doesn't match the conditions
                return item;
              });

              window.groceryList[0]['Aangepaste boodschappenlijst'] = newArray;
            }
          });
        }

        if (amountCounter > 2 && groceryListEl === null) {
          amountCounter -= 1;

          amountElToChange.dataset.amount = newAmount;
          amountElToChange.innerHTML = newAmount;

          if (addToGroceryListEl) {
            addToGroceryListEl.setAttribute('data-amount-of-people', newAmount);
          }

          ingredientAmountEls.forEach((ingredientAmountEl) => {
            const { amountSingle } = ingredientAmountEl.dataset;
            const { amountOriginal } = ingredientAmountEl.dataset;
            let newValue =
              (parseFloat(amountOriginal) / parseFloat(amountOfPeople)) * parseFloat(amountCounter);

            // wss gewoon amount single vermenigvuldigen maal amount single

            if (amountCounter === amountOfPeople) {
              newValue = parseFloat(amountOriginal);
            }

            if (newValue > 0) {
              if (amountSingle.includes('.')) {
                // Handle decimal numbers
                const roundedValue = parseFloat(newValue.toFixed(2));
                const formattedValue = formatNumber(roundedValue);

                ingredientAmountEl.dataset.amountCurrent = roundedValue;
                ingredientAmountEl.innerHTML = formattedValue;
              } else {
                ingredientAmountEl.dataset.amountCurrent = newValue;
                ingredientAmountEl.innerHTML = newValue;
              }
            }
          });
        }
      });
    });
  }
}
